import React, { PureComponent } from 'react';
import { createUser } from "../../../api/apiRequests";
import MyInput from "../../shared/form/MyInput";
import PieceOfInfo from "../../shared/PieceOfInfo";
import MySubmit from "../../shared/form/MySubmit";

class ModalNewUser extends PureComponent {

  state = {
    name: "",
    surname: "",
    address: "",
    cp: "",
    location: "",
    city: "",
    country: "",
    birthDay: "",
    birthMonth: "",
    birthYear: "",
    nationality: "",
    passport: "",
    driversLicense: "",
    phone: "",
    emailConfirm: "",
    email: "",
    password: "",
  };
  errors = [];

  captureErrors = (where, isCorrect) => {
    const indice = this.errors.indexOf(where);
    const existsIndice = indice >= 0;
    isCorrect ? (existsIndice && this.errors.splice(indice, 1)) : (!existsIndice && this.errors.push(where));
  };

  changeInfo = (event) => this.setState({
    [event.target.name]: (event.target.value)
  });

  submit = (event) => {
    event.preventDefault();
    if (this.errors.length < 1) {
      const { refreshUsers, changeModal } = this.props;
      const { employee } = this.props;
      createUser({
        ...this.state,
        password: (employee ? this.state.password : ("fk-pssw-" + this.state.email)),
        passwordConfirmation: (employee ? this.state.password : ("fk-pssw-" + this.state.email)),
        role: (employee ? "admin" : "customer")
      })
      .then(() => {
        alert("El " + (employee ? "empleado" : "cliente") + " ha sido creado correctamente");
        refreshUsers();
        changeModal(null);
      })
      .catch(() => {
        alert("¡Ups!, el " + (employee ? "empleado" : "cliente") + " no se ha podido crear")
      })
    } else {
      alert("Todos los campos son obligatorios")
    }
  };

  render() {
    const info = this.state;
    const { employee } = this.props;
    return (
      <div className="bg-white p-5"
           style={{ minWidth: "300px", width: "90vw", maxWidth: "1500px", minHeight: "200px" }}>
        <form onSubmit={this.submit} className="row">
          <div className="col-12">
            <PieceOfInfo title={"Información de " + (employee ? "empleado" : "cliente")}/>
            <div className="row">
              <div className="col-12 col-md-6">
                <MyInput title="Nombre" type="text" name="name" value={info.name}
                         onChange={this.changeInfo} captureErrors={this.captureErrors} notEmpty={true}
                         className="mr-md-2"/>
              </div>
              <div className="col-12 col-md-6">
                <MyInput title="Apellidos" type="text" name="surname" value={info.surname}
                         onChange={this.changeInfo} captureErrors={this.captureErrors} notEmpty={true}
                         className="ml-md-2"/>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-8">
                <MyInput title="Dirección" type="text" name="address" value={info.address}
                         onChange={this.changeInfo} captureErrors={this.captureErrors} notEmpty={true}
                         className="mr-md-2"/>
              </div>
              <div className="col-6 col-md-4">
                <MyInput title="CP" type="text" name="cp" value={info.cp}
                         onChange={this.changeInfo} captureErrors={this.captureErrors} notEmpty={true}
                         className="ml-md-2"/>
              </div>
              <div className="col-6 col-md-4">
                <MyInput title="Localidad" type="text" name="location" value={info.location}
                         onChange={this.changeInfo} captureErrors={this.captureErrors} notEmpty={true}
                         className="mr-md-2"/>
              </div>
              <div className="col-6 col-md-4">
                <MyInput title="Ciudad" type="text" name="city" value={info.city}
                         onChange={this.changeInfo} captureErrors={this.captureErrors} notEmpty={true}
                         className="mr-md-2 ml-md-2"/>
              </div>
              <div className="col-6 col-md-4">
                <MyInput title="País" type="text" name="country" value={info.country}
                         onChange={this.changeInfo} captureErrors={this.captureErrors} notEmpty={true}
                         className="ml-md-2"/>
              </div>
            </div>
            {!employee &&
            <React.Fragment>
              <div className="row my-font-sz-08 my-font-wg-500 mb-1">Fecha de nacimiento</div>
              <div className="row">
                <div className="col-4">
                  <MyInput title="Día" type="number" name="birthDay" value={info.birthDay}
                           onChange={this.changeInfo} captureErrors={this.captureErrors} notEmpty={true}
                           className="mr-md-2"/>
                </div>
                <div className="col-4">
                  <MyInput title="Mes" type="number" name="birthMonth" value={info.birthMonth}
                           onChange={this.changeInfo} captureErrors={this.captureErrors} notEmpty={true}
                           className="mx-md-2"/>
                </div>
                <div className="col-4">
                  <MyInput title="Año" type="number" name="birthYear" value={info.birthYear}
                           onChange={this.changeInfo} captureErrors={this.captureErrors} notEmpty={true}
                           className="ml-md-2"/>
                </div>
              </div>
            </React.Fragment>
            }
            <div className="row">
              <div className="col-12 col-sm-6">
                <MyInput title="Nacionalidad" type="text" name="nationality" value={info.nationality}
                         onChange={this.changeInfo} captureErrors={this.captureErrors} notEmpty={true}
                         className="mr-md-2"/>
              </div>
              <div className="col-12 col-sm-6">
                <MyInput title="Nº pasaporte O ID" type="text" name="passport" value={info.passport}
                         onChange={this.changeInfo} captureErrors={this.captureErrors} notEmpty={true}
                         className="ml-md-2"/>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-sm-6">
                <MyInput title="Nº licencia de conducir" type="text" name="driversLicense"
                         value={info.driversLicense}
                         onChange={this.changeInfo} captureErrors={this.captureErrors} notEmpty={true}
                         className="mr-md-2"/>
              </div>
              <div className="col-12 col-sm-6">
                <MyInput title="Télefono" type="number" name="phone" value={info.phone}
                         onChange={this.changeInfo} captureErrors={this.captureErrors} maxChar={20} minChar={9}
                         notEmpty={true}
                         className="ml-md-2"/>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-sm-6">
                <MyInput title="Email" type="text" name="email" value={info.email}
                         onChange={this.changeInfo} captureErrors={this.captureErrors} notEmpty={true}
                         className="mr-md-2"/>
              </div>
              <div className="col-12 col-sm-6">
                <MyInput title="Confirmación Email" type="email" name="emailConfirm" value={info.emailConfirm}
                         onChange={this.changeInfo} captureErrors={this.captureErrors} notEmpty={true}
                         equal={info.email} className="ml-md-2"/>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-6">
                {employee &&
                <MyInput title="Contraseña" type="password" name="password" value={info.password}
                         onChange={this.changeInfo} captureErrors={this.captureErrors} notEmpty={true}
                         className="mr-md-2"/>
                }
              </div>
              <div className="col-12 col-md-6">
                <div style={{ paddingTop: "12px" }} className="row ml-md-2 mt-3">
                  <MySubmit style={{ height: "48px" }} text={"CREAR " + (employee ? "EMPLEADO" : "CLIENTE")}
                            className="bg-success"/>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default ModalNewUser;
